module.exports = __webpack_public_path__ + "img/level_VN.15d41db2.png";